export const BASE_URL = "https://remixedstories.ca/";

const authString = "remixed_app:GuillaumeTheGreat";
export const AUTH_HEADERS = { authorization: `Basic ${btoa(authString)}` };
